/**
 * @generated SignedSource<<dbfc73993b06a1e7f9c1b4257493927c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsAmpEnabledArticle$data = {
  readonly disableOffPlatformContent: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly entityId: string;
  readonly published: boolean;
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly sponsorType: string | null | undefined;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusArticle">;
  readonly " $fragmentType": "helpersCheckIsAmpEnabledArticle";
};
export type helpersCheckIsAmpEnabledArticle$key = {
  readonly " $data"?: helpersCheckIsAmpEnabledArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsAmpEnabledArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsAmpEnabledArticle"
};

(node as any).hash = "88ecb22e711ac9bc2124c56abeb3dd6c";

export default node;
